import React from 'react';

const Profile = ({ match }) => {
    return (
        <div className="Profile">{match.params.username}</div>
    )
}

export default Profile;